import React, { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
type Announcement = {
  address: string;
  schedule: string;
};
const announcements: Announcement[] = [{
  address: "18 Harbour Isle Dr #102",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}, {
  address: "20 Harbour Isle Dr W #106",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}];
export function OpenHouseAnnouncement() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }
    const interval = window.setInterval(() => {
      setActiveIndex(index => (index + 1) % announcements.length);
    }, 4800);
    return () => window.clearInterval(interval);
  }, [prefersReducedMotion]);
  const announcement = announcements[activeIndex];
  return <aside className="border-b border-amber-200/35 bg-amber-100 px-5 py-3 text-stone-950 sm:px-10 lg:px-14" aria-label="Open house announcements" data-id="element-38" data-mp="2ahx5x9ehxh5y">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-center gap-3" aria-live="polite" data-id="element-39" data-mp="22xwno7n4ymke">
        <span className="hidden shrink-0 text-xs font-bold uppercase tracking-[0.16em] text-amber-900 sm:inline" data-id="element-40" data-mp="1xzd2waka3gtm">Featured</span>
        <motion.div key={activeIndex} className="min-w-0 text-center" initial={prefersReducedMotion ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-41" data-mp="27umzgirwqw00">
          <p className="text-sm font-bold leading-5 sm:inline sm:text-base" data-id="element-42" data-mp="1tv58pxv1x8o0">
            {announcement.address}
          </p>
          <p className="text-xs font-semibold leading-5 text-amber-900 sm:ml-3 sm:inline sm:text-sm" data-id="element-43" data-mp="1p4f1ef32evqo">
            {announcement.schedule}
          </p>
        </motion.div>
      </div>
    </aside>;
}